import EventEmitter from '../../../../utility/event-emitter';
export default class TokboxSubscriberListener extends EventEmitter {
    constructor($injector, subscriber) {
        super();
        this.$injector = $injector;
        this.subscriber = subscriber;
        this.$interval = this.$injector.get('$interval');
        this.$log = this.$injector.get('$log');
        this.trackNoAudio();
    }
    trackNoAudio() {
        let noSoundTracked = false;
        let previousBytesReceived = 0;
        const INTERVAL = 15000;
        const interval = this.$interval(() => {
            if (!this.subscriber.stream)
                return;
            this.subscriber.getStats((err, stats) => {
                if (!this.subscriber.stream)
                    return;
                this.$log.debug('TokboxSubscriberListener:stats', stats.audio, this.subscriber.stream.hasAudio);
                const noSoundDetected = stats.audio.bytesReceived === previousBytesReceived &&
                    this.subscriber.stream.hasAudio;
                previousBytesReceived = stats.audio.bytesReceived;
                if (noSoundDetected) {
                    this.$log.debug('TokboxSubscriberListener:noSoundDetected', stats.audio, this.subscriber.stream.hasAudio, previousBytesReceived);
                    if (!noSoundTracked) {
                        this.$log.debug('TokboxSubscriberListener:noSoundEmited', stats.audio, this.subscriber.stream.hasAudio);
                        this.emit('no-sound');
                        noSoundTracked = true;
                    }
                }
                else {
                    if (noSoundTracked) {
                        this.$log.debug('TokboxSubscriberListener:sound-back', stats.audio, this.subscriber.stream.hasAudio);
                        noSoundTracked = false;
                    }
                }
            });
        }, INTERVAL);
        this.subscriber.on('destroyed', () => {
            this.$interval.cancel(interval);
        });
    }
}
